<template>
  <mdb-container class="testStudio rounded z-depth-1">
    <mdb-row class="testStudio__wrapper no-gutters d-flex">
      <mdb-col md="6">
        <h2 class="testStudio_heading--big">
          Custom Location: {{ displayedName }}
        </h2>
      </mdb-col>
      <mdb-col md="6" class="d-flex justify-content-end">
        <a
          class="btn btn-sm btn-isi-secondary px-3 m-0 mt-2 mt-md-0"
          @click="
            $emit('removeCustomLocation', {
              customLocationId: customLocation.id,
            })
          "
        >
          <span>Remove</span>
        </a>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>

export default {
  name: "CustomLocation",
  props: {
    customLocation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayedName() {
      if (this.customLocation.city) {
        return this.customLocation.city + " - " + this.customLocation.country;
      } else {
        return this.customLocation.country;
      }
    },
  },
};
</script>